import React, { FC } from 'react';
import { PersonSvg } from 'components/Icons/PersonSvg';
import variables from 'styles/variables.scss';
import { EyeClosedIcon } from 'shared/ui';
import { convertDateFormString } from 'utils/convertDateAndTime/dateTimeFormating';
import { GPTCallComment as GPTComment } from 'store/calls/calls.types';
import { translate } from 'localizations';
import s from './styles.module.scss';

type CommentHeader = Pick<
	GPTComment,
	'editorName' | 'creatorName' | 'editTime' | 'addTime' | 'isPrivate' | 'deal' | 'call'
>;
interface CommentHeaderProps extends CommentHeader {
	lang: string;
}
const CommentHeader: FC<CommentHeaderProps> = ({
	editorName,
	creatorName,
	editTime,
	addTime,
	isPrivate,
	deal,
	call,
	lang,
}) => (
	<div className={s.head}>
		{editorName || creatorName ? (
			<div className={s.author}>
				<PersonSvg fill="#738094" />
				<span>{editorName || creatorName}</span>
			</div>
		) : null}
		{editTime || addTime ? <div className={s.time}>{convertDateFormString(editTime || addTime || '')}</div> : null}
		{isPrivate && <EyeClosedIcon pathFill={variables.gray_7} />}
		{deal && (
			<div className={s.whose}>
				<span style={{ backgroundColor: variables.cyan_4 }} className={s.circle}></span>
				{translate('deal', lang)}
			</div>
		)}
		{call && (
			<div className={s.whose}>
				<span style={{ backgroundColor: variables.geekblue_4 }} className={s.circle}></span>
				{translate('call', lang)}
			</div>
		)}
	</div>
);

export default CommentHeader;
